import React from 'react'
import '../assets/styles/PageLoading.css'

const PageLoading = () => (
  <>  
    <div className="PageLoading">
      <div className="lds-grid">
        <div /><div /><div />
      </div>
    </div>
  </>
)

export default PageLoading